var Z = Object.defineProperty, ee = Object.defineProperties;
var te = Object.getOwnPropertyDescriptors;
var Y = Object.getOwnPropertySymbols;
var se = Object.prototype.hasOwnProperty, le = Object.prototype.propertyIsEnumerable;
var q = (s, n, t) => n in s ? Z(s, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[n] = t, p = (s, n) => {
  for (var t in n || (n = {}))
    se.call(n, t) && q(s, t, n[t]);
  if (Y)
    for (var t of Y(n))
      le.call(n, t) && q(s, t, n[t]);
  return s;
}, $ = (s, n) => ee(s, te(n));
import { computed as i, unref as e, provide as ne, inject as ae, defineComponent as y, toRefs as z, openBlock as c, createBlock as m, normalizeClass as u, withCtx as b, createElementVNode as B, createElementBlock as k, toDisplayString as M, createCommentVNode as v, normalizeStyle as W, ref as ce, resolveDynamicComponent as V, mergeProps as G, withDirectives as oe, createVNode as D, vShow as re, renderSlot as C, useCssVars as J, createTextVNode as L, useSlots as ie, createSlots as ue } from "vue";
import { BTooltip as de, BImage as A } from "@bilibili-intl/components";
import { BAvatar as _e } from "@bilibili-intl/avatar";
const me = /* @__PURE__ */ new Map([
  ["en", {
    fav: "My List"
  }],
  ["th", {
    fav: "รายการโปรด"
  }],
  ["id", {
    fav: "Favorit Saya"
  }],
  ["vi", {
    fav: "Yêu thích"
  }],
  ["ms", {
    fav: "Senarai saya"
  }]
]), K = Symbol("videoCardContext"), ve = (s) => {
  const n = $(p({}, s), {
    lang: i(() => me.get(e(s.locale)))
  });
  ne(K, n);
}, T = () => {
  const s = ae(K);
  if (!s)
    throw new Error("inject must use after provider");
  return s;
}, he = {
  name: "CoverFav"
}, fe = /* @__PURE__ */ y($(p({}, he), {
  props: {
    favored: { type: [Boolean, null] }
  },
  emits: ["click"],
  setup(s, { emit: n }) {
    const t = s, { favored: l } = z(t), { classPrefix: o, lang: a } = T(), r = `${o}__cover-fav`, d = i(() => [
      r,
      {
        [`${r}--active`]: !!e(l)
      }
    ]), h = `${r}-icon`, _ = () => {
      n("click", !e(l));
    };
    return (f, x) => {
      var w;
      return c(), m(e(de), {
        class: u(e(d)),
        trigger: "hover",
        placement: "bottom",
        content: (w = e(a)) == null ? void 0 : w.fav,
        "show-arrow": !1,
        offset: 8
      }, {
        default: b(() => [
          B("i", {
            class: u(h),
            onClick: _
          })
        ]),
        _: 1
      }, 8, ["class", "content"]);
    };
  }
}));
const ge = {
  name: "CoverRanking"
}, pe = /* @__PURE__ */ y($(p({}, ge), {
  props: {
    rank: null
  },
  setup(s) {
    const n = s, { rank: t } = z(n), { isMobile: l, classPrefix: o } = T(), a = `${o}__cover-ranking`, r = i(() => [a, { [`${a}--${["first", "second", "third"][e(t) - 1]}`]: e(t) < 4, [`${a}--mobile`]: e(l) }]), d = new Map(
      Array(4).fill("https://p.bstarstatic.com/fe-lib/images/web/rank-").map((_, f) => [f + 1, `${_}${f + 1}.png`])
    ), h = i(() => {
      var _;
      return (_ = d.get(e(t))) != null ? _ : d.get(4);
    });
    return (_, f) => (c(), k("p", {
      class: u(e(r))
    }, [
      B("span", null, M(e(t)), 1),
      e(h) ? (c(), m(e(A), {
        key: 0,
        src: e(h),
        width: 84,
        height: 84
      }, null, 8, ["src"])) : v("", !0)
    ], 2));
  }
}));
const $e = ["src"], ke = {
  name: "CoverMask"
}, ye = /* @__PURE__ */ y($(p({}, ke), {
  props: {
    text: null,
    img: null,
    bold: { type: Boolean }
  },
  setup(s) {
    const n = s, { text: t, img: l, bold: o } = z(n), { classPrefix: a, isMobile: r } = T(), d = `${a}__cover-mask`, h = i(() => [
      d,
      {
        [`${d}--img`]: e(l),
        [`${d}--mobile`]: e(r)
      }
    ]), _ = i(() => [`${d}-text`, { [`${d}-text--bold`]: e(o) }]), f = i(
      () => {
        var x, w, P, S;
        return e(l) ? {
          width: (x = e(l)) != null && x.width ? `${(w = e(l)) == null ? void 0 : w.width}px` : "auto",
          height: (P = e(l)) != null && P.height ? `${(S = e(l)) == null ? void 0 : S.height}px` : "auto"
        } : {};
      }
    );
    return (x, w) => (c(), k("div", {
      class: u(e(h))
    }, [
      e(t) ? (c(), k("span", {
        key: 0,
        class: u(e(_))
      }, M(e(t)), 3)) : v("", !0),
      e(l) ? (c(), k("img", {
        key: 1,
        class: u(`${d}-img`),
        src: e(l).src,
        style: W(e(f)),
        alt: ""
      }, null, 14, $e)) : v("", !0)
    ], 2));
  }
}));
const xe = {
  name: "CoverLabel"
}, we = /* @__PURE__ */ y($(p({}, xe), {
  props: {
    text: null,
    size: null,
    pink: { type: Boolean }
  },
  setup(s) {
    const n = s, { pink: t, size: l } = z(n), { classPrefix: o } = T(), a = `${o}__cover-label`, r = i(() => [a, `${a}--${e(l)}`, { [`${a}--pink`]: e(t) }]);
    return (d, h) => (c(), k("span", {
      class: u(e(r))
    }, M(s.text), 3));
  }
}));
const be = {
  name: "CoverProgress"
}, Ce = /* @__PURE__ */ y($(p({}, be), {
  props: {
    progress: null,
    size: null
  },
  setup(s) {
    const n = s, { progress: t } = z(n), { classPrefix: l } = T(), o = `${l}__cover-progress`, a = i(() => ({ width: `${e(t)}%` }));
    return (r, d) => (c(), k("div", {
      class: u(o)
    }, [
      B("span", {
        class: u([`${o}-bar`, `${o}-bar--${s.size}`]),
        style: W(e(a))
      }, null, 6)
    ]));
  }
}));
const ze = {
  name: "Cover"
}, Te = /* @__PURE__ */ y($(p({}, ze), {
  props: {
    card: null,
    size: null,
    fav: null,
    width: null,
    boldMaskText: { type: Boolean },
    newWindow: { type: Boolean },
    lazyLoad: { type: Boolean }
  },
  emits: ["fav-click"],
  setup(s, { emit: n }) {
    const t = s, { card: l, size: o, fav: a, width: r, newWindow: d } = z(t), { classPrefix: h, onClick: _, isMobile: f } = T(), x = `${h}__cover`, w = i(() => e(l).url ? "a" : "div"), P = i(() => r != null && r.value ? Math.floor(r.value * 9 / 16) : 0), S = i(() => e(r) ? { width: `${e(r)}px`, height: `${e(P)}px` } : {}), H = i(() => e(a) !== "hidden"), F = i(() => [x, `${x}--${e(o)}`]), U = i(() => [
      { [`${x}-fav--hover`]: e(a) === "hover" }
    ]), R = i(() => ({
      [`${x}-wrap`]: !0,
      [`${x}-wrap--mobile`]: e(f)
    })), g = i(
      () => e(l).url ? { href: e(l).url, target: e(d) ? "_blank" : "_self" } : {}
    ), I = (E) => {
      n("fav-click", E);
    }, j = ce(!1), X = () => j.value = !0;
    return (E, Ye) => (c(), k("div", {
      class: u(e(R))
    }, [
      B("div", {
        class: u(e(F)),
        style: W(e(S))
      }, [
        (c(), m(V(e(w)), G(e(g), { onClick: e(_) }), {
          default: b(() => [
            oe(D(e(A), {
              class: u(`${x}-img`),
              src: e(l).cover,
              alt: e(l).title,
              width: e(r) || 720,
              height: e(P) || 405,
              loading: s.lazyLoad ? "lazy" : "eager",
              "open-avif": !0,
              onError: X
            }, null, 8, ["class", "src", "alt", "width", "height", "loading"]), [
              [re, !j.value]
            ])
          ]),
          _: 1
        }, 16, ["onClick"])),
        C(E.$slots, "cover-mask", {}, () => [
          e(l).maskText || e(l).maskImg ? (c(), m(ye, {
            key: 0,
            text: e(l).maskText,
            img: e(l).maskImg,
            bold: s.boldMaskText
          }, null, 8, ["text", "img", "bold"])) : v("", !0)
        ]),
        e(l).labelText ? (c(), m(we, {
          key: 0,
          text: e(l).labelText,
          size: e(o),
          pink: e(l).pinkLabel
        }, null, 8, ["text", "size", "pink"])) : v("", !0),
        e(l).progress ? (c(), m(Ce, {
          key: 1,
          progress: e(l).progress,
          size: e(o)
        }, null, 8, ["progress", "size"])) : v("", !0),
        e(H) ? (c(), m(fe, {
          key: 2,
          class: u(e(U)),
          favored: e(l).favored,
          onClick: I
        }, null, 8, ["class", "favored"])) : v("", !0)
      ], 6),
      e(l).rank ? (c(), m(pe, {
        key: 0,
        rank: e(l).rank
      }, null, 8, ["rank"])) : v("", !0)
    ], 2));
  }
}));
const Be = {
  name: "CardTitle"
}, Me = /* @__PURE__ */ y($(p({}, Be), {
  props: {
    card: null,
    size: null,
    more: null,
    bold: { type: Boolean },
    newWindow: { type: Boolean }
  },
  setup(s) {
    const n = s;
    J((S) => ({
      c1d38bc4: e(d)
    }));
    const { card: t, size: l, bold: o, more: a } = z(n), { classPrefix: r, titleMaxLines: d, onClick: h } = T(), _ = `${r}__title`, f = i(() => e(t).url ? "a" : "span"), x = i(() => e(a) !== "hidden"), w = i(() => [
      _,
      `${_}--${e(l)}`,
      {
        [`${_}--bold`]: e(o),
        [`${_}--more`]: e(x)
      }
    ]), P = i(() => [
      `${r}__more`,
      `${r}__more--${e(a)}`
    ]);
    return (S, H) => (c(), k("p", {
      class: u(e(w))
    }, [
      (c(), m(V(e(f)), {
        class: u(`${e(r)}__title-text`),
        href: e(t).url,
        target: s.newWindow ? "_blank" : "_self",
        onClick: e(h)
      }, {
        default: b(() => [
          L(M(e(t).title), 1)
        ]),
        _: 1
      }, 8, ["class", "href", "target", "onClick"])),
      e(x) ? (c(), k("span", {
        key: 0,
        class: u(e(P))
      }, [
        C(S.$slots, "more")
      ], 2)) : v("", !0)
    ], 2));
  }
}));
const Pe = {
  name: "CardTag"
}, Se = /* @__PURE__ */ y($(p({}, Pe), {
  setup(s) {
    const { classPrefix: n } = T();
    return (t, l) => (c(), k("span", {
      class: u(`${e(n)}__tag`)
    }, [
      C(t.$slots, "default")
    ], 2));
  }
}));
const Le = /* @__PURE__ */ y({
  __name: "cert",
  props: {
    src: null
  },
  setup(s) {
    const { classPrefix: n } = T(), t = `${n}__cert-icon`;
    return (l, o) => (c(), m(e(A), {
      class: u(t),
      src: s.src,
      width: 32,
      height: 32,
      loading: "lazy"
    }, null, 8, ["src"]));
  }
});
const We = {
  name: "Nickname"
}, O = /* @__PURE__ */ y($(p({}, We), {
  props: {
    user: null,
    size: null
  },
  setup(s) {
    const n = s, { user: t } = z(n), { classPrefix: l, onUserClick: o } = T(), a = i(() => e(t).link ? "a" : "p"), r = i(
      () => e(t).link ? { href: e(t).link, target: e(t).newWindow ? "_blank" : "_self" } : {}
    );
    return (d, h) => e(t).hideNickname ? v("", !0) : (c(), m(V(e(a)), G({
      key: 0,
      class: [`${e(l)}__nickname`, `${e(l)}__nickname--${s.size}`]
    }, e(r), { onClick: e(o) }), {
      default: b(() => [
        B("span", null, M(e(t).nickname), 1),
        e(t).certUrl ? (c(), m(Le, {
          key: 0,
          src: e(t).certUrl
        }, null, 8, ["src"])) : v("", !0)
      ]),
      _: 1
    }, 16, ["class", "onClick"]));
  }
}));
const De = {
  name: "DescText"
}, N = /* @__PURE__ */ y($(p({}, De), {
  props: {
    size: null,
    icon: { type: Boolean, default: !1 },
    highlight: { type: Boolean, default: !1 }
  },
  setup(s) {
    const n = s;
    J((_) => ({
      "1f04dac5": e(r)
    }));
    const { size: t, icon: l, highlight: o } = z(n), { classPrefix: a, descMaxLines: r } = T(), d = `${a}__desc`, h = i(() => [d, `${d}--${e(t)}`, { [`${d}--icon`]: e(l), [`${d}--highlight`]: e(o) }]);
    return (_, f) => (c(), k("p", {
      class: u(e(h))
    }, [
      C(_.$slots, "default")
    ], 2));
  }
}));
const He = {
  name: "Avatar"
}, Q = /* @__PURE__ */ y($(p({}, He), {
  props: {
    user: null,
    size: null
  },
  setup(s) {
    const n = s, { user: t, size: l } = z(n), { onUserClick: o } = T(), a = i(() => e(l) === "small" ? 14 : 36);
    return (r, d) => (c(), m(e(_e), {
      avatar: e(t).avatar,
      nickname: e(t).nickname,
      link: e(t).link,
      width: e(a),
      pendant: e(t).pendant,
      "new-window": e(t).newWindow,
      onClick: e(o)
    }, null, 8, ["avatar", "nickname", "link", "width", "pendant", "new-window", "onClick"]));
  }
})), Ne = {
  name: "CardRowText"
}, Ve = /* @__PURE__ */ y($(p({}, Ne), {
  props: {
    card: null,
    descHighlight: { type: Boolean }
  },
  setup(s) {
    const n = s, { card: t } = z(n), { classPrefix: l } = T(), o = `${l}__text`, a = i(() => [o, `${o}--row`, { [`${o}--user`]: e(t).user }]), r = i(() => {
      var _, f;
      return ((_ = e(t).user) == null ? void 0 : _.nickname) && !((f = e(t).user) != null && f.hideNickname);
    }), d = i(() => e(t).watched || e(r) || e(t).desc), h = i(() => [`${o}-desc`, {
      tag: e(t).watched,
      nickname: e(r),
      desc: e(t).desc
    }]);
    return (_, f) => (c(), k("div", {
      class: u(e(a))
    }, [
      e(t).user ? (c(), m(Q, {
        key: 0,
        user: e(t).user,
        size: "normal"
      }, null, 8, ["user"])) : v("", !0),
      B("div", {
        class: u(`${o}-content`)
      }, [
        C(_.$slots, "title"),
        C(_.$slots, "desc", {}, () => [
          e(d) ? (c(), k("div", {
            key: 0,
            class: u(e(h))
          }, [
            e(t).watched ? (c(), m(Se, { key: 0 }, {
              default: b(() => [
                L(M(e(t).watched), 1)
              ]),
              _: 1
            })) : v("", !0),
            e(r) && e(t).user ? (c(), m(O, {
              key: 1,
              user: e(t).user,
              size: "normal"
            }, null, 8, ["user"])) : v("", !0),
            e(t).desc ? (c(), m(N, {
              key: 2,
              size: "normal",
              icon: e(t).type === "live",
              highlight: s.descHighlight
            }, {
              default: b(() => [
                L(M(e(t).desc), 1)
              ]),
              _: 1
            }, 8, ["icon", "highlight"])) : v("", !0)
          ], 2)) : v("", !0),
          e(t).subDesc ? (c(), m(N, {
            key: 1,
            size: "normal",
            highlight: s.descHighlight
          }, {
            default: b(() => [
              L(M(e(t).subDesc), 1)
            ]),
            _: 1
          }, 8, ["highlight"])) : v("", !0)
        ])
      ], 2)
    ], 2));
  }
}));
const Fe = {
  name: "CardColumnText"
}, Ue = /* @__PURE__ */ y($(p({}, Fe), {
  props: {
    card: null,
    descHighlight: { type: Boolean }
  },
  setup(s) {
    const { classPrefix: n } = T();
    return (t, l) => (c(), k("div", {
      class: u([`${e(n)}__text`, `${e(n)}__text--column`])
    }, [
      C(t.$slots, "title"),
      C(t.$slots, "desc", {}, () => [
        s.card.user ? (c(), k("div", {
          key: 0,
          class: u(`${e(n)}__user`)
        }, [
          D(Q, {
            user: s.card.user,
            size: "small"
          }, null, 8, ["user"]),
          D(O, {
            user: s.card.user,
            size: "small"
          }, null, 8, ["user"])
        ], 2)) : v("", !0),
        s.card.desc ? (c(), m(N, {
          key: 1,
          size: "small",
          highlight: s.descHighlight
        }, {
          default: b(() => [
            L(M(s.card.desc), 1)
          ]),
          _: 1
        }, 8, ["highlight"])) : v("", !0),
        s.card.subDesc ? (c(), m(N, {
          key: 2,
          size: "small"
        }, {
          default: b(() => [
            L(M(s.card.subDesc), 1)
          ]),
          _: 1
        })) : v("", !0)
      ])
    ], 2));
  }
}));
const Re = {
  name: "CardText"
}, Ee = /* @__PURE__ */ y($(p({}, Re), {
  props: {
    card: null,
    layout: null,
    titleSize: null,
    more: null,
    boldTitle: { type: Boolean },
    descHighlight: { type: Boolean },
    newWindow: { type: Boolean }
  },
  setup(s) {
    const n = s, { layout: t } = z(n), l = ie(), o = {
      row: Ve,
      column: Ue
    };
    return (a, r) => (c(), m(V(o[e(t)]), {
      card: s.card,
      "desc-highlight": s.descHighlight
    }, ue({
      title: b(() => [
        C(a.$slots, "title", {}, () => [
          D(Me, {
            card: s.card,
            size: s.titleSize,
            more: s.more,
            "new-window": s.newWindow,
            bold: s.boldTitle
          }, {
            more: b(() => [
              C(a.$slots, "more")
            ]),
            _: 3
          }, 8, ["card", "size", "more", "new-window", "bold"])
        ])
      ]),
      _: 2
    }, [
      e(l).desc ? {
        name: "desc",
        fn: b(() => [
          C(a.$slots, "desc")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["card", "desc-highlight"]));
  }
}));
const Ae = {
  name: "VideoCardSkeleton"
}, Ie = /* @__PURE__ */ y($(p({}, Ae), {
  props: {
    layout: null,
    width: null,
    skeletonType: { default: "ogv" }
  },
  setup(s) {
    const n = s, { layout: t, width: l, skeletonType: o } = z(n), a = "bstar-video-card-skeleton", r = i(() => [
      a,
      `${a}--${e(t)}`,
      `${a}--${e(o)}`
    ]), d = i(() => ({
      "grid-template-columns": l != null && l.value && (t == null ? void 0 : t.value) === "column" ? `${l == null ? void 0 : l.value}px 1fr` : "auto",
      width: l != null && l.value && (t == null ? void 0 : t.value) === "row" ? `${l.value}px` : "auto"
    })), h = i(() => e(l) ? { width: `${e(l)}px` } : {});
    return (_, f) => (c(), k("div", {
      class: u(e(r)),
      style: W(e(d))
    }, [
      B("div", {
        class: u(`${a}__cover`),
        style: W(e(h))
      }, null, 6),
      B("div", {
        class: u(`${a}__text-warp`)
      }, [
        e(o) === "ugc" ? (c(), k("div", {
          key: 0,
          class: u(`${a}__avatar`)
        }, null, 2)) : v("", !0),
        B("div", {
          class: u(`${a}__text-content`)
        }, [
          B("div", {
            class: u(`${a}__text`)
          }, null, 2),
          B("div", {
            class: u(`${a}__text`)
          }, null, 2),
          B("div", {
            class: u(`${a}__text`)
          }, null, 2)
        ], 2)
      ], 2)
    ], 6));
  }
}));
const je = {
  name: "VideoCard"
}, Oe = /* @__PURE__ */ y($(p({}, je), {
  props: {
    card: null,
    locale: { default: "en" },
    layout: { default: "row" },
    titleSize: { default: "small" },
    coverSize: null,
    more: { default: "hidden" },
    fav: { default: "hidden" },
    width: null,
    isMobile: { type: Boolean, default: !1 },
    boldTitle: { type: Boolean, default: !0 },
    boldMaskText: { type: Boolean, default: !0 },
    descHighlight: { type: Boolean, default: !1 },
    newWindow: { type: Boolean, default: !0 },
    lazyLoad: { type: Boolean, default: !0 },
    titleMaxLines: { default: 2 },
    descMaxLines: { default: 2 },
    loading: { type: Boolean, default: !1 },
    skeletonType: { default: "ogv" }
  },
  emits: ["click", "user-click", "fav-click"],
  setup(s, { emit: n }) {
    const t = s, { card: l, locale: o, layout: a, more: r, width: d, isMobile: h, coverSize: _, titleMaxLines: f, descMaxLines: x } = z(t), w = "bstar-video-card", P = i(() => {
      var g;
      return [
        w,
        `${w}--${e(a)}`,
        `${w}--${(g = e(l)) == null ? void 0 : g.type}`
      ];
    }), S = i(() => {
      var g;
      return e(_) ? (g = e(_)) != null ? g : "normal" : e(a) === "column" ? "small" : "normal";
    }), H = i(() => e(d) && e(a) === "column" ? { "grid-template-columns": `${e(d)}px 1fr` } : {}), F = (g) => {
      l != null && l.value && n("click", { card: l.value, e: g });
    }, U = (g) => {
      l != null && l.value && n("user-click", { card: l.value, e: g });
    }, R = (g) => {
      n("fav-click", g);
    };
    return ve({
      classPrefix: w,
      isMobile: h,
      locale: o,
      titleMaxLines: f,
      descMaxLines: x,
      onClick: F,
      onUserClick: U
    }), (g, I) => s.loading || !e(l) ? (c(), m(Ie, {
      key: 0,
      "skeleton-type": s.skeletonType,
      width: e(d),
      layout: e(a)
    }, null, 8, ["skeleton-type", "width", "layout"])) : (c(), k("div", {
      key: 1,
      class: u(e(P)),
      style: W(e(H))
    }, [
      D(Te, {
        card: e(l),
        size: e(S),
        fav: s.fav,
        width: e(d),
        "bold-mask-text": s.boldMaskText,
        "new-window": s.newWindow,
        "lazy-load": s.lazyLoad,
        onFavClick: R
      }, {
        "cover-mask": b(() => [
          C(g.$slots, "cover-mask")
        ]),
        _: 3
      }, 8, ["card", "size", "fav", "width", "bold-mask-text", "new-window", "lazy-load"]),
      B("div", {
        class: u(`${w}__text-wrap`)
      }, [
        D(Ee, {
          card: e(l),
          layout: e(a),
          "title-size": s.titleSize,
          more: e(r),
          "bold-title": s.boldTitle,
          "desc-highlight": s.descHighlight,
          "new-window": s.newWindow
        }, {
          title: b(() => [
            C(g.$slots, "title")
          ]),
          more: b(() => [
            C(g.$slots, "more")
          ]),
          desc: b(() => [
            C(g.$slots, "desc")
          ]),
          _: 3
        }, 8, ["card", "layout", "title-size", "more", "bold-title", "desc-highlight", "new-window"])
      ], 2)
    ], 6));
  }
}));
export {
  O as Nickname,
  Oe as VideoCard
};
//# sourceMappingURL=video-card.es.js.map
